<template>
  <el-dialog
    :visible.sync="visible"
    title="上传合同"
    width="660px"
    @close="resetDialogData"
  >
    <ContractContent 
      :disabled="disabledContract" 
      :shopId="shopId"
      :shopName="shopName"
      ref="contractContentRef" 
    />
    <div class="audit-section upload-container">
      <span class="upload-title"><span style="color: #f56c6c;margin-right: 4px;">*</span>合同附件</span>
      <div>
        <ossFileUpload
          ref="refPicFileUpload"
          v-model="picFileList"
          :limit="maxFileCount"
          :accept="picFileExt"
          :maxFileLength="10"
          :ossUpload="true"
          :ossPathDir="'shop/pic/'"
          style="margin-bottom: 10px"
          :disabled="isDisabled"
          :onPreview="handlePreview"
        >
        </ossFileUpload>
        <div class="small-tip warning" v-if="!isDisabled">
          <span
            >最多支持{{ maxFileCount }}张，单张不超过10M； 支持{{
              picFileExt
            }}</span
          >
        </div>
      </div>
    </div>
    <!-- 审核区域 -->
    <div
      class="audit-section"
      v-show="form.auditResult && form.auditResult != 0"
    >
      <el-form :model="form" ref="formRef" label-width="80px">
        <el-form-item label="审核结果" prop="auditResult">
          <div>{{ checkStatusMap[form.auditResult] }}</div>
        </el-form-item>
        <!-- 驳回理由 -->
        <el-form-item
          v-if="form.auditResult === 2"
          label="驳回理由"
          prop="rejectReason"
        >
          <div>{{ form.rejectReason }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="submitUpload"
        :loading="uploading"
        v-show="form.auditResult == null || form.auditResult == 2"
      >
        保存
      </el-button>
    </div>
    <FileViewer ref="fileViewerRef" />
  </el-dialog>
</template>

<script>
import FileViewer from "@/components/FileViewer";
import ossFileUpload from "@/components/ossFileUpload";
import { getToken } from "@/utils/auth";
import { createContract } from "@/api/compliance/contractManager";
import { getOssSrcFileName } from "@/utils/oss";
import ContractContent from "./contract-content.vue";
export default {
  name: "ContractFileUpload",
  components: {
    ossFileUpload,
    FileViewer,
    ContractContent,
  },
  props: {},
  data() {
    return {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      uploading: false,
      picFileList: [],
      picFileExt: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
      maxFileCount: 9,
      isDisabled: false,
      visible: false,
      contractCode: "",
      form: {
        auditResult: null, // 1:通过, 2:驳回
        rejectReason: "",
      },
      checkStatusMap: {
        0: "待审核",
        1: "通过",
        2: "驳回",
      },
      submitDisable: false,
      disabledContract: false, //合同信息禁用
      shopId: "",
      shopName: "",
      contractId: "",//合同id
    };
  },
  methods: {
    handlePreview(file) {
      const { url } = file;
      if (url) {
        this.$refs.fileViewerRef.publicOpen(url);
      }
    },
    handleClose() {
      this.visible = false;
      this.resetDialogData();
    },
    publicOpen(contract) {
      const { shopId , shopName} = this.$store.state.user.user_info;
      this.shopId = shopId;
      this.shopName = shopName;
      if(contract && contract.id){
        const { id, fileUrl, checkStatus, checkRemark, contractCode } = contract;
        this.contractId = id;
        this.form.auditResult = checkStatus;
        this.form.rejectReason = checkRemark;
        this.submitDisable = checkStatus !== 0;
        this.isDisabled = [0,1].includes(checkStatus); //审核通过了 就不能修改了
        this.disabledContract = checkStatus !== 2;
        if (fileUrl) {
          const urls = fileUrl.split(",");
          this.picFileList = urls.map((item) => {
            return this.parseToUploadUrl(item);
          });
        }else{
          this.picFileList = [];
        }
        this.$nextTick(() => {
          this.$refs.contractContentRef.initForm(contract);
        })
      }else{
        this.form.auditResult = null;
        this.form.rejectReason = "";
        this.submitDisable = false;
        this.isDisabled = false;
      }
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.refPicFileUpload.init(); //初始化oss上传
      });
    },
    async submitUpload() {
      const contractForm = await this.$refs.contractContentRef.getForm();
      if(!contractForm){
        return;
      }
      if(this.picFileList.length == 0){
        this.$message.error('请上传合同附件');
        return;
      }
      this.uploading = true;
      const files = this.picFileList.map((item) => ({
        url: item.response.data.url,
      }));
      const params = {
        ...contractForm,
        fileUrl: files.map((item) => item.url).join(","),
      }
      if(this.contractId){
        params.id = this.contractId;
      }
      createContract(params).then((res) => {
        this.uploading = false;
        this.visible = false;
        this.$emit("uploadSuccess");
      }).catch(() => {
        this.uploading = false;
      });
    },
    parseToUploadUrl(newUrl) {
      if (newUrl) {
        const name = getOssSrcFileName(newUrl); //newUrl.split("/");
        return {
          name: name,
          url: newUrl,
          response: { data: { fileName: name, url: newUrl } },
        };
      }
      return null;
    },
    resetDialogData() {
      this.shopId = "";
      this.shopName = "";
      this.disabledContract = false;
      this.picFileList = [];
      this.$refs.refPicFileUpload.release();
      this.$refs.formRef.resetFields();
      this.$refs.formRef.clearValidate();
      this.$refs.contractContentRef.resetForm();
    },
  },
};
</script>

<style scoped lang="scss">
.upload-container {
  margin-bottom: 20px;
  display: flex;
  .upload-title {
    width: 80px;
    text-align: right;
    padding-right: 12px;
    font-size: 14px;
    color: #262626;
  }
}

.dialog-footer {
  text-align: right;
}

.audit-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>